// extracted by mini-css-extract-plugin
export default {"bimWorkOrderActKc2PriceDetail":"BimWorkOrderActKc2PriceDetails_bimWorkOrderActKc2PriceDetail__SHKA2"};